import { MinusCircleFilledSize24, CheckCircleFilledSize24 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Notification from 'src/components/Notifications/Notification';
import { NotificationProps } from 'src/components/Notifications/Provider/types';
import translation from 'src/components/translation';

interface LocalProps {
    isError?: boolean;
}

const TrlKeys = {
    error: 'resumeCard.openContacts.snackbar.error.text',
    success: 'resumeCard.openContacts.snackbar.success.text',
};

const NotificationComponent: TranslatedComponent<LocalProps & NotificationProps> = ({ trls, isError, ...props }) => (
    <Notification
        addon={
            isError ? (
                <MinusCircleFilledSize24 initialColor="negative" />
            ) : (
                <CheckCircleFilledSize24 initialColor="positive" />
            )
        }
        autohideTime={3000}
        {...props}
    >
        {trls[TrlKeys[isError ? 'error' : 'success']]}
    </Notification>
);

export default translation(NotificationComponent);
